// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2qPbS","heading":"Footer_heading__2ZE8M"};